<template>
  <div
    class="common-inner-card flex-center-center"
    @click.stop="changeCollapse"
  >
    <div class="collapse-text">
      <div v-if="isCollapse">
        余
        <span>{{ num }}</span>
        项
      </div>
      <span v-else>收起</span>
      <div :class="isCollapse ? 'arrow-icon-down' : 'arrow-icon-up'"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    num: {
      type: Number,
      default: 0,
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    changeCollapse() {
      this.$emit("changeCollapse");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.collapse-text {
  margin-right: 4px;
  color: #666;
  text-align: right;
  font-family: PingFang SC;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
}
.arrow-position {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
}
.arrow-icon-down {
  .arrow-position;
  .connect-bg(16px, 16px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/arrow-icon.png");
  transform: translateY(-50%) rotate(180deg);
}
.arrow-icon-up {
  .arrow-position;
  .connect-bg(16px, 16px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/arrow-icon.png");
}
</style>
